import Mana from './Mana'
import reactStringReplace from 'react-string-replace'
import styles from '../styles/Card.module.scss'
import { useSelector } from 'react-redux'

const getSynergyLabel = ({
  commander,
  label,
  num_decks,
  potential_decks,
  synergy,
}) => {
  try {
    return reactStringReplace(label, /synergy/g, (match) => (
      <span className={styles.synergy}>
        {' synergy'}
        <span className={styles.synergyTooltip}>
          <div className={styles.synergyTooltipBody}>
            <span className={styles.left}>synergy = </span>
            <span>
              <div>
                usage in {commander.name.split(' // ')[0]} (
                {Math.round((100 * num_decks) / potential_decks)}
                %)
              </div>
              <div>
                - usage in <Mana colors={commander.color_identity} /> (
                {Math.round(
                  Math.round((100 * num_decks) / potential_decks) -
                    100 * synergy
                )}
                %)
              </div>
            </span>
          </div>
        </span>
      </span>
    ))
  } catch (error) {
    return label
  }
}

const CardLabel = ({ label, num_decks, potential_decks, synergy }) => {
  const commander = useSelector(
    (state) => state.pagedata.data?.container.json_dict.card
  )
  const synergyLabel = getSynergyLabel({
    commander,
    label,
    num_decks,
    potential_decks,
    synergy,
  })
  return (
    <div className={styles.label}>
      {commander?.is_commander ? synergyLabel : label}
    </div>
  )
}

export default CardLabel
